module.exports = __webpack_public_path__ + "media/images/animations/axle_spacing/6-8905a8a787efce2e6f69f3285c393fd1.png";